import { graphql } from '@/generated/gql';

export const CMDI_META_QUERY = graphql(/* GraphQL */ `
  query CustomDataNavListCmdiMeta {
    cmdi {
      meta_entity {
        id
        name
        i18n
        needsPermission
      }
    }
  }
`);
